/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { DeliveryDetailsProps } from '../lxs-anonymous-delivery.data';
import DetailedDeliveryInformation from './detailed-delivery-information';
import MainCarriage from './main-carriage';

const DeliveryDetails: React.FC<DeliveryDetailsProps> = ({ CLASS_NAME, events, mainCarriage, resources, localizationState, context }) => (
    <div className={`${CLASS_NAME}__container-sub`}>
        <DetailedDeliveryInformation
            CLASS_NAME={CLASS_NAME}
            events={events}
            resources={resources}
            localizationState={localizationState}
            context={context}
        />
        <MainCarriage CLASS_NAME={CLASS_NAME} mainCarriage={mainCarriage} resources={resources} />
    </div>
);

export default DeliveryDetails;
